import React, { useEffect } from 'react';

import './PopUp.css';

const PopUp = ({ isShowPopUpModal, setIsShowPopUpModal }) => {
    // закрытие PopUp через 2 секунды
    useEffect(() => {
        if (isShowPopUpModal) {
            const successTimer = setTimeout(() => {
                setIsShowPopUpModal(false);
            }, 2500);

            return () => clearTimeout(successTimer);
        }
    }, [isShowPopUpModal]);

    return (
        <div className='popup__wrapper'>
            <div className='popup__items'>
                <p>Персонал скоро подойдет к Вам, ожидайте</p>
            </div>
        </div>
    );
};

export default PopUp;
